export default __webpack_public_path__ + "static/media/Kollam-Kottarakkara-Diocese.5956e923.png";